import { useState, useRef } from 'react';
import Actions from './Actions'
import Buttons from './Buttons';

const ButtonItems = (vm) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const btnRef = useRef(null);
    const menuRef = useRef(null);

    Actions({menuOpen, btnRef, menuRef, setMenuOpen})

    const buttons = Buttons({
        activeTab: vm.activeTab,
        onTabChange: vm.onTabChange,
        permission: vm.permission,
        losesAccess: vm.losesAccess,
        navOpen,
        setMenuOpen,
        setNavOpen
    })

    return {
        navOpen,
        btnRef,
        menuOpen,
        menuRef,
        navBtn: buttons.navBtn,
        bondaAdminBtn: buttons.bondaAdminBtn,
        setMenuOpen,
        setNavOpen
    };
};

export default ButtonItems;
